<!-- 了解详情 -->
<template>
  <div class="main">
    <h2>卓悦访谈录 | 服务顾问曾敬威：做客户最放心的服务者</h2>
    2019-10-31
    <br />
    <br />
    <img alt="" src="../../assets/img/protal/learnMore1-1.jpg"><br />
    <br />
    <strong>曾敬威</strong><br />
    服务顾问<br />
    佛山坤宝<br /><br />

    <strong>导语：</strong><br /><br />
    入职五年，月均接待三百台车，日均服务十几位客户，微信中一千多个客户微信。这些数字构成曾敬威忙碌的背影，大量的沟通交流是服务顾问的工作基本。一边是同事，一边是客户，只有超强的协调能力和过硬的专业知识才能做到最好的服务。
    <br />
    <br />
    <br />
    <strong>信任换来老客户</strong><br />
    <br />
    客户毛先生是曾敬威5年前相识的。毛先生爱车，懂车，去过不同的4S店对服务都不满意。第一次到店，看着分配给他的曾敬威一脸年轻，就更没报什么期望。<div class="blueColor">曾敬威用自己的高效、专业打动了客户，从此客户就认准了他。每次维修都要驱车几十公里到店，指名要曾敬威接待，直言自己对别人不信任。</div>
    <br /><br />
    2017年8月，客户到店常规保养。车子已经使用十年，行驶 45万公里，大小毛病都有。每次维修时间都不短，这一次情况更加复杂。曾敬威给客户解释完每一个维修项目后，客户只是若有所思地点点头。
    <br /><br />
    <img alt="" src="../../assets/img/protal/learnMore1-2.jpg"><br />
    <br />
    看客户好像不了解车子严重性，曾敬威索性带客户到车间，把车子举升起来，一一指出需要维修的问题。这时候客户才明白车子的严重性，看着总价三万多元的总维修费用，客户突然问他：“阿威，你说我这个车还值得维修吗？”
    <br /><br />
    曾敬威明白客户的忧虑。他请公司的二手评估师给车子做了评估，最终估价十万元。曾敬威从自己的角度给客户进行分析，“<div class="blueColor">影响到安全的地方肯定要修，其他部分可以看情况。但从我们二手车评价看，维修确实不如买新车。您可以对比一下，根据自己的需求做决定。</div>”从客户角度出发的一番话朴实理性。
    <br /><br />
    客户回去后，很快给他回复，选择维修。收到客户的消息，曾敬威忙安排维修师傅开工。交车前，他特别安排师傅给车子清洗发动机舱，车身抛光。见到焕然一新的爱车，客户非常欣喜，“阿威啊，这车要不是因为你，我就把它卖了。虽然清远广州都有宝马4s店，但我还是觉得找你放心，舒服。即使远点，也就多个十几分钟的路程，无所谓了。”
    <br /><br />
    <img alt="" src="../../assets/img/protal/learnMore1-3.jpg"><br />
    <br />
    这样只认曾敬威服务的客户有很多。客户们都说，只信得过他。曾敬威说维系两年以上的客户才称得上“老客户”。他也有这样的自信，手机联系人中一千多个客户基本都是维系几年以上的老客户，每一位客户的用车习惯和维修需求他也都记得清清楚楚。
    <br />
    <div class="button">
      <el-button size="medium"
                 type="primary"
                 class="backButton"
                 @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img1: '../../assets/img/banner1.jpg'
    }
  },
  methods: {
    back() {
      this.$router.replace({ name: 'protalMain' })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  line-height: 24px;
  font-size: 15px;
  padding-top: 30px;
  width: 70%;
  margin: 0 auto;
  img {
    width: 100%;
  }
  .blueColor {
    display: inline;
    background-color: blue;
    color: white;
  }
}
.button {
  margin: 20px auto;
  width: 300px;
  .backButton {
    width: 160px;
    height: 36px;
    font-size: 14px;
  }
}
</style>
